import React from 'react';
import { InputProps, Input, InputRefs } from '@tcl-argon-foundations/input';

export interface TextInputProps extends Omit<InputProps, 'onChange'> {
  /** A handler called whenever this input changes. The new value is passed as the only argument to the callback. */
  onChange: (value: string) => void;
  /** The text value of this component */
  value: string;
}

export const TextInput = React.forwardRef<InputRefs, TextInputProps>(function TextInput({ onChange, ...props }, ref) {
  // TODO I know this is correct but I don't know how to explain it to Typescript
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Input ref={ref as any} type="string" onChange={(e) => onChange(e.target.value)} {...props} />;
});
